/**
 * 智慧用能菜单配置
 * @type {Array}
 */
const menu = [
    {
        id: "main_show",   // 菜单项id(必须唯一)
        path: "/main_show", // id路径
        menuItemName: "用能概览",  // 菜单项名称
        menuItemIcon: "home",   // 菜单项图标
        leaf: false,   // 是否为菜单项   false: 目录   true: 菜单项
        children: [
            {
                id: "main_show_org",
                path: "/main_show/main_show_org", // id路径
                menuItemName: "运营商总览",
                moduleActionPath: "/app/smart_energy/energy_overview/operator_overview",   // 动作路径（对应 route-config.js中的路由）
                leaf: true,   // 是否为菜单项
                children: []
            },
        ]
    },
    {
        id: "energy_manager",   // 菜单项id(必须唯一)
        path: "/energy_manager", // id路径
        menuItemName: "用能管理",  // 菜单项名称
        menuItemIcon: "home",   // 菜单项图标
        leaf: false,   // 是否为菜单项   false: 目录   true: 菜单项
        children: [
            {
                id: "energy_monitor",
                path: "/energy_manager/energy_monitor", // id路径
                menuItemName: "用能监测",
                moduleActionPath: "/app/smart_energy/energy_mgt/energy_monitor",   // 动作路径（对应 route-config.js中的路由）
                leaf: true,   // 是否为菜单项
                children: []
            },
            {
                id: "energy_analyze",
                path: "/energy_manager/energy_analyze", // id路径
                menuItemName: "用能分析",
                moduleActionPath: "/app/smart_energy/energy_mgt/energy_analyze",   // 动作路径（对应 route-config.js中的路由）
                leaf: true,   // 是否为菜单项
                children: []
            },{
                id: "terminal_monitoring",
                path: "/energy_manager/terminal_monitoring", // id路径
                menuItemName: "终端在线监测",
                moduleActionPath: "/app/smart_energy/energy_terminal_monitoring/terminal_monitoring/Terminal",   // 动作路径（对应 route-config.js中的路由）
                leaf: true,   // 是否为菜单项
                children: []
            },{
                id: "video_monitor",
                path: "/energy_manager/video_monitor", // id路径
                menuItemName: "视频监控",
                moduleActionPath: "/app/agency_maintain/components/run_monitor/video_monitor",   // 动作路径（对应 route-config.js中的路由）
                leaf: true,   // 是否为菜单项
                children: []
            }
        ]
    },
    {
        id: "energy_plan",   // 菜单项id(必须唯一)
        path: "/energy_plan", // id路径
        menuItemName: "用能计划",  // 菜单项名称
        menuItemIcon: "home",   // 菜单项图标
        leaf: false,   // 是否为菜单项   false: 目录   true: 菜单项
        children: [
            {
                id: "plan",
                path: "/energy_plan/plan", // id路径
                menuItemName: "用能计划",
                moduleActionPath: "/app/smart_energy/energy_plan/plan",   // 动作路径（对应 route-config.js中的路由）
                leaf: true,   // 是否为菜单项
                children: []
            },
            {
                id: "management",
                path: "/energy_plan/management", // id路径
                menuItemName: "事件查询",
                moduleActionPath: "/app/smart_energy/energy_plan/management",   // 动作路径（对应 route-config.js中的路由）
                leaf: true,   // 是否为菜单项
                children: []
            },
            {
                id: "profit",
                path: "/energy_plan/profit", // id路径
                menuItemName: "管控收益",
                moduleActionPath: "/app/smart_energy/energy_plan/profit",   // 动作路径（对应 route-config.js中的路由）
                leaf: true,   // 是否为菜单项
                children: []
            }
        ]
    },{
        id: "rush_to_repair",   // 菜单项id(必须唯一)
        path: "/rush_to_repair", // id路径
        menuItemName: "工单管理",  // 菜单项名称
        menuItemIcon: "home",   // 菜单项图标
        leaf: false,   // 是否为菜单项   false: 目录   true: 菜单项
        children: [
            {
                id: "rush_to_repair",
                path: "/rush_to_repair/rush_to_repair/Index", // id路径
                menuItemName: "事件工单",
                moduleActionPath: "/app/smart_energy/energy_terminal_monitoring/rush_to_repair",   // 动作路径（对应 route-config.js中的路由）
                leaf: true,   // 是否为菜单项
                children: []
            }
        ]
    },
    {
        id: "load_regulation",   // 菜单项id(必须唯一)
        path: "/load_regulation", // id路径
        menuItemName: "负荷调控",  // 菜单项名称
        menuItemIcon: "home",   // 菜单项图标
        leaf: false,   // 是否为菜单项   false: 目录   true: 菜单项
        children: [
            {
                id: "load_regulation-load_regulation",
                path: "/load_regulation/load_regulation", // id路径
                menuItemName: "负荷调控",
                moduleActionPath: "/app/smart_energy/load_regulation/load_regulation",   // 动作路径（对应 route-config.js中的路由）
                leaf: true,   // 是否为菜单项
                children: []
            },
            {
                id: "load_regulation-load_search",
                path: "/load_regulation/load_search", // id路径
                menuItemName: "负荷效果查询",
                moduleActionPath: "/app/smart_energy/load_regulation/load_search",   // 动作路径（对应 route-config.js中的路由）
                leaf: true,   // 是否为菜单项
                children: []
            }
        ]
    },

    {
        id: "information_maintain",   // 菜单项id(必须唯一)
        path: "/information_maintain", // id路径
        menuItemName: "信息维护",  // 菜单项名称
        menuItemIcon: "home",   // 菜单项图标
        leaf: false,   // 是否为菜单项   false: 目录   true: 菜单项
        children: [
            {
                id: "space",
                path: "/information_maintain/space", // id路径
                menuItemName: "空间档案管理",
                moduleActionPath: "/app/smart_energy/information_maintain/IntelEnergy",   // 动作路径（对应 route-config.js中的路由）
                leaf: true,   // 是否为菜单项
                children: []
            },{
                id: "space",
                path: "/information_maintain/user", // id路径
                menuItemName: "用户档案管理",
                moduleActionPath: "/app/smart_energy/information_maintain/enery_user",   // 动作路径（对应 route-config.js中的路由）
                leaf: true,   // 是否为菜单项
                children: []
            },
            {
                id: "terminalManagement",
                path: "/information_maintain/terminalManagement", // id路径
                menuItemName: "终端管理",
                moduleActionPath: "/app/common/ledger/terminal",   // 动作路径（对应 route-config.js中的路由）
                leaf: true,   // 是否为菜单项
                children: []
            },
            {
                id: "meterManagement",
                path: "/information_maintain/meterManagement", // id路径
                menuItemName: "表计管理",
                moduleActionPath: "/app/common/ledger/meter",   // 动作路径（对应 route-config.js中的路由）
                leaf: true,   // 是否为菜单项
                children: []
            },{
                id: "air",
                path: "/information_maintain/air", // id路径
                menuItemName: "空调经济运行模型维护",
                moduleActionPath: "/app/smart_energy/information_maintain/air_model",   // 动作路径（对应 route-config.js中的路由）
                leaf: true,   // 是否为菜单项
                children: []
            },
            {
                id: "monitor",
                path: "/information_maintain/monitor", // id路径
                menuItemName: "监控设备管理",
                moduleActionPath: "/app/agency_maintain/components/ledger/monitor",   // 动作路径（对应 route-config.js中的路由）
                leaf: true,   // 是否为菜单项
                children: []
            },{
                id: "air",
                path: "/information_maintain/air", // id路径
                menuItemName: "计费方案维护",
                moduleActionPath: "/app/smart_energy/temp_mgt/elec_temp",   // 动作路径（对应 route-config.js中的路由）
                leaf: true,   // 是否为菜单项
                children: []
            },
        ]
    }, {
        id: "meter_mgt",   // 菜单项id(必须唯一)
        path: "/meter_mgt", // id路径
        menuItemName: "装接管理",  // 菜单项名称
        menuItemIcon: "home",   // 菜单项图标
        leaf: false,   // 是否为菜单项   false: 目录   true: 菜单项
        children: [
            {
                id: "meter_mgt_meter_mgt",
                path: "/meter_mgt/meter_mgt_meter_mgt", // id路径
                menuItemName: "装接查询",
                moduleActionPath: "/app/smart_energy/meter_mgt/meter_mgt",   // 动作路径（对应 route-config.js中的路由）
                leaf: true,   // 是否为菜单项
                children: []
            },
        ]
    },
    {
        id: "energy_report",   // 菜单项id(必须唯一)
        path: "/energy_report", // id路径
        menuItemName: "能耗分析报告",  // 菜单项名称
        menuItemIcon: "home",   // 菜单项图标
        leaf: false,   // 是否为菜单项   false: 目录   true: 菜单项
        children: [
            {
                id: "create",
                path: "/energy_report/energy_create", // id路径
                menuItemName: "能耗分析报告(生成报告)",
                moduleActionPath: "/app/smart_energy/energy_report/energy_create",   // 动作路径（对应 route-config.js中的路由）
                leaf: true,   // 是否为菜单项
                children: []
            },
            {
                id: "already",
                path: "/energy_report/energy_already", // id路径
                menuItemName: "能耗分析报告(已存报告)",
                moduleActionPath: "/app/smart_energy/energy_report/energy_already",   // 动作路径（对应 route-config.js中的路由）
                leaf: true,   // 是否为菜单项
                children: []
            }
        ]
    }, {
        id: "report_management",   // 菜单项id(必须唯一)
        path: "/report_management", // id路径
        menuItemName: "报表管理",  // 菜单项名称
        menuItemIcon: "home",   // 菜单项图标
        leaf: false,   // 是否为菜单项   false: 目录   true: 菜单项
        children: [
            {
                id: "report_management-report_form",
                path: "/report_management/report_form", // id路径
                menuItemName: "用能报表",
                moduleActionPath: "/app/smart_energy/energy_consumption/report_form",   // 动作路径（对应 route-config.js中的路由）
                leaf: true,   // 是否为菜单项
                children: []
            },
            {
                id: "report_management-profitReport",
                path: "/report_management/profitReport", // id路径
                menuItemName: "管控收益报表",
                moduleActionPath: "/app/smart_energy/energy_consumption/profitReport",   // 动作路径（对应 route-config.js中的路由）
                leaf: true,   // 是否为菜单项
                children: []
            }
        ]
    },
]

export default menu;
